import React, { useState } from 'react';
import { ChevronDown, History, Plus, RotateCcw, Trash2, Zap } from 'lucide-react';
import { Checkbox } from './ui/checkbox';
import { Button } from './ui/button';
import { Input } from './ui/input';

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }) : '');

export const AdsPhaseCard = ({ phase, onToggle, onAdd, onDelete, onReset, onHistory, busy }) => {
  const [open, setOpen] = useState(phase.done_count < phase.items.length);
  const [texto, setTexto] = useState('');
  const total = phase.items.length;
  const complete = total > 0 && phase.done_count === total;
  const t = `ads-phase-${phase.id}`;

  const add = () => { if (texto.trim()) { onAdd(phase.id, texto.trim()); setTexto(''); } };

  return (
    <div className={`rounded-xl border ${complete ? 'border-emerald-200 bg-emerald-50/40' : 'bg-card'}`} data-testid={t}>
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center gap-3 px-4 py-3 text-left" data-testid={`${t}-toggle`}>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? '' : '-rotate-90'}`} />
        <span className="font-semibold flex-1">{phase.titulo}{phase.recurrente && <span className="ml-2 text-[10px] uppercase tracking-wider text-amber-700 bg-amber-100 rounded px-1.5 py-0.5">Recurrente</span>}</span>
        <span className={`text-sm tabular-nums ${complete ? 'text-emerald-700 font-semibold' : 'text-muted-foreground'}`} data-testid={`${t}-counter`}>{phase.done_count} de {total}</span>
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-1.5">
          {phase.recurrente && (
            <div className="flex items-center justify-between text-xs text-muted-foreground pb-1">
              <span>{phase.ciclo_desde ? `Ciclo actual desde el ${fmt(phase.ciclo_desde)}` : 'Primer ciclo'}</span>
              <div className="flex gap-1">
                <Button variant="ghost" size="sm" className="h-7" onClick={() => onHistory(phase.id)} data-testid={`${t}-history-btn`}><History className="w-3.5 h-3.5 mr-1" />Ciclos anteriores</Button>
                <Button variant="outline" size="sm" className="h-7" onClick={() => onReset(phase)} data-testid={`${t}-reset-btn`}><RotateCcw className="w-3.5 h-3.5 mr-1" />Cerrar ciclo y reiniciar</Button>
              </div>
            </div>
          )}
          {phase.items.map((it) => (
            <div key={it.id} className="flex items-start gap-2.5 group py-1" data-testid={`ads-item-${it.id}`}>
              <Checkbox checked={it.hecho} disabled={busy === it.id || it.por_estado} onCheckedChange={(v) => onToggle(it.id, !!v)} className="mt-0.5" data-testid={`ads-item-check-${it.id}`} />
              <div className="flex-1 min-w-0">
                <p className={`text-sm ${it.hecho ? 'line-through text-muted-foreground' : ''}`}>{it.texto}</p>
                {it.hecho && <p className="text-[11px] text-muted-foreground">{it.hecho_por}{it.hecho_at ? ` · ${fmt(it.hecho_at)}` : ''}</p>}
              </div>
              {it.auto && <Zap className="w-3.5 h-3.5 text-amber-500 mt-0.5 shrink-0" title={it.id.includes('_st_') ? 'Se marca sola cuando todas las publicaciones del mes alcanzan ese estado' : 'Se marca sola desde el portal'} />}
              {it.custom && <button type="button" onClick={() => onDelete(it.id)} className="opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`ads-item-delete-${it.id}`}><Trash2 className="w-3.5 h-3.5 text-red-500" /></button>}
            </div>
          ))}
          <div className="flex gap-2 pt-1">
            <Input value={texto} onChange={(e) => setTexto(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && add()} placeholder="Añadir tarea propia de este cliente" className="h-8 text-sm" data-testid={`${t}-add-input`} />
            <Button size="sm" variant="secondary" className="h-8" onClick={add} data-testid={`${t}-add-btn`}><Plus className="w-4 h-4" /></Button>
          </div>
        </div>
      )}
    </div>
  );
};
